import React, { Component } from 'react';
import AssignmentSearchParams from '../AssignmentSearchParams';
import ProjectAssignmentService from '../../../../../Services/ProjectAssignmentsService';
import ShownPanelsEnum from '../../../../../Enums/ShownPanelsEnum';
import AllAssignmentItem from '../../../../../Domain/AllAssignmentItem';
import TabOfDataTable from '../../../../../Elements/DataTable/TabOfDataTable';

class AssignmentsListBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemList: [],
      selected: -1,
      selectedItem: null,
      orderBy: 'AsSassieAsgnId',
      orderDirection: 'Asc',
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      searchItem: this.getSearchParameters(new AssignmentSearchParams()),
      shownPanel: ShownPanelsEnum.None,
      allItemInTheSearchAreSelected: false,
      availableContacts: [],
    };

    this.getSearchParameters = this.getSearchParameters.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.showPanel = this.showPanel.bind(this);
  }

  startSearch(searchItem) {
    this.setState({ searchItem });
  }

  getSearchParameters(searchItem) {
    return {
      ...(searchItem ?? this.state.searchItem),
      AsCfId:
        this.props.type === 'finalized'
          ? this.props.Item.CfId
          : this.props.type === 'finalized_client'
          ? this.props.Item.ClientId
          : this.props.CfId,
      AssignmentType: this.props.type,
    };
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      this.setState({ searchItem: { ...this.state.searchItem } });
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    return null;
  }

  renderButtonsAndPanels() {
    return (
      <div>
        {this.renderActionButtons()}
        {this.renderPanels()}
      </div>
    );
  }

  renderActionButtons() {
    return null;
  }

  getDisplayType() {
    return AllAssignmentItem;
  }

  changeOfItemListFunction(itemList, numberOfElementsInTheTable, pageNumber) {
    this.setState({
      itemList: itemList,
      numberOfElementsInTheTable: numberOfElementsInTheTable,
      pageNumber: pageNumber,
    });
  }

  getTabOfDataTable() {
    return (
      <TabOfDataTable
        type={AllAssignmentItem}
        shownPanel={this.state.shownPanel}
        serviceFunction={ProjectAssignmentService.GetAssignmentList}
        convertDBItemsFunction={ProjectAssignmentService.ConvertAllDBItems}
        searchItem={this.state.searchItem}
        searchParamsType={AssignmentSearchParams}
        orderDirection={this.state.orderDirection}
        clickOnStartSearch={this.startSearch}
        showSearchStrip={true}
        enableUrlPush={false}
        changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
          this.setState({ allItemsInTheSearchSetAreSelected });
        }}
        itemTypeName={'assignments'}
        errorCode='ALB129'
      />
    );
  }

  render() {
    return (
      <div>
        {this.renderButtonsAndPanels()}
        {this.getTabOfDataTable()}
      </div>
    );
  }
}

export default AssignmentsListBase;
